import { Grouping } from '@yleisradio/areena-types';
import { MenuGroup } from './MenuGroup';
import { MenuList } from './MenuList';
import styles from './MenuSection.module.scss';
import { FunctionComponent } from 'react';

type Props = {
  grouping: Grouping;
  toggleSubMenu(): void;
};

export const MenuSection: FunctionComponent<Props> = ({
  grouping,
  toggleSubMenu,
}) => {
  return (
    <div className={styles.section} key={grouping.tag}>
      <MenuList
        key={grouping.tag}
        controls={grouping.controls}
        groupTag={grouping.tag}
        toggleSubMenu={toggleSubMenu}
      />
      {grouping.groupings
        ? grouping.groupings.map((subGrouping, index) => (
            <MenuGroup
              grouping={subGrouping}
              key={index}
              toggleSubMenu={toggleSubMenu}
            />
          ))
        : null}
    </div>
  );
};
